import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import { ICompanyRequest } from './types';
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';

interface IInstanceRow {
  instance: ICompanyRequest;
  onClick: () => void;
}

export default function InstanceRow(props:IInstanceRow) {
  const {
    instance,
    onClick
  } = props

  const renderPhone = (number:string|null) => {
    if(!number) return "";

    return (
      <NumberFormat value={number} displayType={'text'} format="+## (###) ### ## ##" />
    )
  }

  return (
    <TableRow hover onClick={onClick} style={{cursor: 'pointer'}}>
      <TableCell style={{whiteSpace: 'nowrap', width: 1}}>
        <Moment
          date={instance.created}
          format="DD.MM.YY HH:mm"
        />
      </TableCell>
      <TableCell>{instance.name}</TableCell>
      <TableCell>{instance.company}</TableCell>
      <TableCell style={{whiteSpace: 'nowrap'}}>{instance.phone ? renderPhone(instance.phone) : null}</TableCell>
      <TableCell>{instance.message}</TableCell>
      <TableCell>{instance.source}</TableCell>
      <TableCell>{instance.utm_source}</TableCell>
    </TableRow>
  );
}